import { render, staticRenderFns } from "./LanguageSelectBox.vue?vue&type=template&id=1c8e703c&scoped=true&"
import script from "./LanguageSelectBox.vue?vue&type=script&lang=ts&"
export * from "./LanguageSelectBox.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageSelectBox.vue?vue&type=style&index=0&id=1c8e703c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8e703c",
  null
  
)

export default component.exports